import { completeKeycloakCallback } from '@/lib/auth/keycloak';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

/** `/auth/callback` — Keycloak redirects here after login. Completes the
 *  Authorization Code exchange, then returns to the app. The exchange
 *  itself fires `userLoaded`, which `keycloak.ts` already wires to
 *  `useAuthStore.setUser()` — this component only owns the redirect and
 *  the (rare) error state. */
export function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    completeKeycloakCallback()
      .then(() => navigate('/', { replace: true }))
      .catch((err: unknown) => {
        console.error('[keycloak] callback failed', err);
        setError(err instanceof Error ? err.message : 'Sign-in failed');
      });
    // Runs once — signinRedirectCallback consumes the one-time code, a
    // second invocation (e.g. from a dep-array re-run) would fail anyway.
    // biome-ignore lint/correctness/useExhaustiveDependencies: intentional — see comment above.
  }, []);

  if (error) {
    return (
      <div className="flex h-dvh flex-col items-center justify-center gap-3 bg-(--color-bg) text-(--color-text)">
        <p className="text-sm text-(--color-red)">Sign-in failed: {error}</p>
        <button
          type="button"
          onClick={() => navigate('/', { replace: true })}
          className="rounded-md border border-(--color-border) px-3 py-1.5 text-sm"
        >
          Back to FLYsafe
        </button>
      </div>
    );
  }

  return (
    <div className="flex h-dvh items-center justify-center bg-(--color-bg) text-(--color-text3) text-sm">
      Signing in…
    </div>
  );
}
